export function decodeJwtPayload(jwt) {
  if (!jwt || typeof jwt !== 'string') {
    return null;
  }

  const base64Url = jwt.split('.')[1]; // Extract the middle part (payload)
  const base64 = base64Url.replace('-', '+').replace('_', '/'); // Fix URL-safe base64 encoding

  try {
    const payloadJson = atob(base64);

    return JSON.parse(payloadJson);
  } catch (error) {
    return null;
  }
}
